import React from 'react';
import DraggableListCard from './DraggableListCard';

/**
 * Section for unpinned (regular) lists in MyLists
 * Uses move up/down buttons for reordering instead of drag-and-drop
 */
function UnpinnedListsSection({
  unpinnedLists,
  isCompactView,
  isReorderMode,
  onDrop,
  onListClick,
  hasPinnedLists,
  maxPinnedLists,
  pinnedCount,
}) {
  const handleMoveUp = (e, list, index) => {
    e.stopPropagation();
    if (index > 0) {
      // Move within unpinned: reorder to index - 1
      onDrop(list.id, 'unpinned', 'unpinned', index - 1);
    }
  };

  const handleMoveDown = (e, list, index) => {
    e.stopPropagation();
    if (index < unpinnedLists.length - 1) {
      // Move within unpinned: reorder to index + 1
      onDrop(list.id, 'unpinned', 'unpinned', index + 1);
    }
  };

  const handlePin = (e, list) => {
    e.stopPropagation();
    // Move from unpinned to pinned at the end
    onDrop(list.id, 'unpinned', 'pinned', pinnedCount);
  };

  const canPin = pinnedCount < maxPinnedLists;

  if (unpinnedLists.length === 0) {
    return null;
  }

  return (
    <div className="unpinned-section">
      {isReorderMode && hasPinnedLists && (
        <div className="unpinned-section-header">
          <span className="unpinned-section-label">Other Lists</span>
        </div>
      )}

      <div className={`unpinned-drop-zone ${isCompactView ? 'compact-view' : ''}`}>
        {unpinnedLists.map((list, index) => (
          <div key={list.id} className="list-item-wrapper">
            {/* Reorder controls */}
            {isReorderMode && (
              <div className="list-reorder-controls">
                <button
                  className="reorder-btn reorder-btn-up"
                  onClick={(e) => handleMoveUp(e, list, index)}
                  disabled={index === 0}
                  aria-label="Move list up"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                    <polyline points="18 15 12 9 6 15" />
                  </svg>
                </button>
                <button
                  className="reorder-btn reorder-btn-down"
                  onClick={(e) => handleMoveDown(e, list, index)}
                  disabled={index === unpinnedLists.length - 1}
                  aria-label="Move list down"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
                {canPin && (
                  <button
                    className="reorder-btn reorder-btn-pin"
                    onClick={(e) => handlePin(e, list)}
                    aria-label="Pin list"
                    title="Pin to top"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M16 4h2v2h-1l-1 4 1.5 1.5L17 13h-3v7l-1 2-1-2v-7H9l-.5-1.5L10 10l-1-4H8V4h8z"/>
                    </svg>
                  </button>
                )}
              </div>
            )}
            <DraggableListCard
              list={list}
              isCompactView={isCompactView}
              isReorderMode={isReorderMode}
              onClick={onListClick}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default UnpinnedListsSection;
